/* src/app/result/popover/popover.page.scss */
.pop-btn {
  margin: 0;
  width: 100%;
  --padding-start: 10px;
  --padding-end: 10px;
  font-size: 1rem;
  font-family: "Lato";
  color: #000;
  border-bottom: 1px solid #e0e0e0;
}
.pop-btn ion-icon {
  margin-right: 5px;
}
.pop-btn:last-child {
  border: none;
}
.pop-btn:hover {
  background: #e0e0e0;
}
.result-popover {
  padding: 5px 0;
}
.active {
  color: var(--color-tabactive);
}
/*# sourceMappingURL=popover.page.css.map */
